var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoweredBy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 21.75,
    viewBox: "0 0 54 21.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-241 -187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Luci",
    transform: "translate(252 205.75)",
    fontSize: 11,
    fontFamily: "Rubik-Bold, Rubik",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Luci")), /*#__PURE__*/React.createElement("text", {
    id: "hub",
    transform: "translate(275 205.75)",
    fontSize: 11,
    fontFamily: "Rubik-Regular, Rubik"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "hub"))), /*#__PURE__*/React.createElement("text", {
    id: "Powered_By",
    "data-name": "Powered By",
    transform: "translate(241 194)",
    fontSize: 8,
    fontFamily: "Rubik-Regular, Rubik"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Powered By")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredBy);
export default __webpack_public_path__ + "static/media/poweredBy.402af268225422b74b4ca9231289c222.svg";
export { ForwardRef as ReactComponent };